import {UntilDestroy} from '@ngneat/until-destroy';
import {Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {CxEvent} from '@spartacus/core';
import {Observable} from 'rxjs';
import {EddlCartCreatedEvent} from './events/eddl-cart-created-event';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DcpEddlCartCreatedService extends DcpDataService<EddlAdobeTrackingData> {

  constructor() {
    super();
  }

  fillData(event: EddlCartCreatedEvent, data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    if (!data.ecommerce) {
      data.ecommerce = {};
    }
    if (!data.ecommerce.cart) {
      data.ecommerce.cart = {};
    }
    data.event = 'cartCreate';
    data.ecommerce.cart.id = event.cart.guid;
    data.ecommerce.cart.currency = event.cart.totalPrice?.currencyIso;
    return data;
  }

  getData(event: CxEvent): Observable<EddlAdobeTrackingData> | EddlAdobeTrackingData {
    if (!(event instanceof EddlCartCreatedEvent)) {
      return undefined;
    }
    return this.fillData(event);
  }
}
